<template>
  <div>
    <v-card>
      <v-toolbar color="primary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('interests') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div v-for="category in interestCategories"
             v-bind:key="category.id"
             class="mb-4">
          <div class="d-flex align-center mb-2">
            <v-icon class="mr-2"
                    color="primary">{{ category.icon }}</v-icon>
            <span class="subtitle-1 font-weight-medium">{{ category.name }}</span>
          </div>
          <v-chip-group column
                        multiple
                        active-class="primary--text"
                        v-bind:value="selectedForCategory(category)"
                        v-on:change="onCategoryChange(category, $event)">
            <v-chip v-for="interest in category.interests"
                    v-bind:key="interest.id"
                    v-bind:value="interest.id"
                    filter
                    outlined>
              {{ interest.name }}
            </v-chip>
          </v-chip-group>
          <v-divider class="mt-2"
                     v-if="!isLastCategory(category)" />
        </div>
        <div v-if="!interestCategories || interestCategories.length === 0"
             class="text--secondary text-center py-4">
          {{ $t('noInterestCategoriesAvailable') }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      lastCategoryId() {
        if (!this.interestCategories || this.interestCategories.length === 0) {
          return null
        }
        return this.interestCategories[this.interestCategories.length - 1].id
      }
    },
    methods: {
      isLastCategory(category) {
        return category.id === this.lastCategoryId
      },
      onCategoryChange(category, selected) {
        const otherIds = (this.value || []).filter(
          id => !category.interests.some(i => i.id === id)
        )
        this.$emit('input', [...otherIds, ...selected])
      },
      selectedForCategory(category) {
        return (this.value || []).filter(
          id => category.interests.some(i => i.id === id)
        )
      }
    },
    name: 'FoodTruckInterestsCard',
    props: {
      interestCategories: {
        default: () => [],
        type: Array
      },
      value: {
        default: () => [],
        type: Array
      }
    }
  }
</script>

<i18n>
  {
    "de": {
      "interests": "Interessen",
      "noInterestCategoriesAvailable": "Keine Interessenkategorien verfügbar."
    },
    "en": {
      "interests": "Interests",
      "noInterestCategoriesAvailable": "No interest categories available."
    }
  }
</i18n>
